import { elementBreite } from "../../assets/js/dom.js";
import { zurPositionScrollen } from "../../assets/js/scroll.js";

class AutorTeaser extends HTMLElement {
    constructor() {
        super();
    }

    async connectedCallback() {
        this.setAttribute('data-js', 'has-js');
        if (this.sliderAnzeigen) this.initSlider();
    }

    /*-------------------------------------------------
    ------ SLIDER -------------------------------------
    -------------------------------------------------*/
    initSlider() {
        this.sliderArtikelListe = this.querySelector('.artikel-slider');
        this.artikelBox = this.querySelector('.artikel');
        this.nachLinksScrollen = this.querySelector('[interaction="nach-links-scrollen"]');
        this.nachRechtsScrollen = this.querySelector('[interaction="nach-rechts-scrollen"]');
        this.initEvents();
        this.initObserver();
        // Fallback, da in einigen Browser der "nach-links-scrollen" Button initial angezeigt wird
        this.nachLinksScrollen.removeAttribute('aktiv');
    }

    initEvents() {
        this.nachRechtsScrollen.addEventListener('click', () => {
            zurPositionScrollen(this.sliderArtikelListe, this.sliderArtikelListe.scrollLeft + elementBreite(this.artikelBox, false));
        });
        this.nachLinksScrollen.addEventListener('click', () => {
            zurPositionScrollen(this.sliderArtikelListe, this.sliderArtikelListe.scrollLeft - elementBreite(this.artikelBox, false));
        });
    }

    initObserver() {
        this.alleArtikel = this.sliderArtikelListe.querySelectorAll('.artikel');
        this.ersterArtikel = this.sliderArtikelListe.querySelector('.artikel:first-of-type');
        this.letzterArtikel = this.sliderArtikelListe.querySelector('.artikel:last-of-type');
        this.options = {
            root: this.sliderArtikelListe,
            threshold: [0.95, 0.96, 0.97, 0.98, 0.99, 1.0]
        };
        this.observer = new IntersectionObserver((entries) => {
            this.nachLinksScrollen.setAttribute('data-status', 'sichtbar');
            this.nachRechtsScrollen.setAttribute('data-status', 'sichtbar');
            entries.forEach(this.updateSlider.bind(this));
        }, this.options);
        this.alleArtikel.forEach(artikel => { this.observer.observe(artikel) });
    }

    updateSlider(entry) {
        this.toggleKontrollElemente(entry);
        if (entry.intersectionRatio >= 0.99) this.navigationAktualisieren(entry.target.dataset.productId);
    }

    toggleKontrollElemente(entry) {
        if (entry.target === this.ersterArtikel && entry.intersectionRatio >= 0.99) this.nachLinksScrollen.setAttribute('data-status', 'versteckt');
        if (entry.target === this.letzterArtikel && entry.intersectionRatio >= 0.99) this.nachRechtsScrollen.setAttribute('data-status', 'versteckt');
    }

    navigationAktualisieren(id) {
        this.querySelector('.navigation[data-status="aktiv"]')?.removeAttribute('data-status');
        this.querySelector(`.navigation[data-product-id="${id}"]`)?.setAttribute('data-status', 'aktiv');
    }

    /*-------------------------------------------------
    ------ GETTER, SETTER & HELPER --------------------
    -------------------------------------------------*/
    get portraitIstZuLang() {
        let paragraphHeight = 0;
        this.querySelectorAll('.portrait-box div').forEach(div => paragraphHeight += div.scrollHeight);
        return paragraphHeight > this.querySelector('.portrait-box').clientHeight;
    }

    get sliderAnzeigen() {
        return this.querySelector('.artikel-slider');
    }
}

customElements.get('autor-teaser') || customElements.define('autor-teaser', AutorTeaser);
